// extracted by mini-css-extract-plugin
export var details = "menuItemDetails-module--details--dac5c";
export var detailsInner = "menuItemDetails-module--details-inner--98c66";
export var imageContainer = "menuItemDetails-module--image-container--ee053";
export var menuItemDetails = "menuItemDetails-module--menu-item-details--fbbc9";